import { useEffect, useState } from 'react'
import 'react-phone-input-2/lib/style.css'
import { Typography, PhoneNumberUtil, PhoneInput } from 'components';
import { validatePhoneNumber } from 'utils';
interface Props {
    inputProps?: Object,
    errorMsg?: String,
    onChange?: Function,
    value?: String,
    phoneNumberError?:Boolean,
    phoneErrorMsg?:String
    disabled?: boolean
}
function PhoneCountryCodeInput({ inputProps, errorMsg, onChange, value, ...props }: Props) {
    const [value1, setValue] = useState<any>(value)
    const [error, setError] = useState(null)

    useEffect(() => {
        setValue(value);
    }, [value])

    useEffect(() => {
        setError(props.phoneErrorMsg);
    }, [props.phoneNumberError,props.phoneErrorMsg])
    
    const onPhoneNumberChange = (value: string, _: any, _e: any, formattedValue: any) => {
        let isValidNumber = true;
        setValue(value)
        if (!value || value === "") {
            setError(errorMsg ? errorMsg : 'Enter a valid phone number');
            isValidNumber = false;
        } else {
            isValidNumber = validatePhone(formattedValue);
        }
        if (onChange) {
            onChange(value, isValidNumber);
        }

    }
    const validatePhone = (inputNumber) => {
        let valid = validatePhoneNumber(inputNumber);
        
        if (!valid) {
            setError(errorMsg ? errorMsg : 'Enter a valid phone number');
        } else {
            setError(null);
        }
        return valid;
    }

    return (
        <>
            <PhoneInput
                country={'us'}
                //  onChange:onPhoneNumberChange
                enableSearch
                autoFormat
                defaultErrorMessage={error}
                countryCodeEditable={false}
                inputProps={{
                    name: "phoneNumber",
                    id: "phoneNumber",
                    required: true,
                    // ref:phoneRef,
                    style: { borderColor: `${error ? 'red' : ''}`, width: '100%' },
                    className: "form-control",
                    // value:formData.phoneNumber,
                    placeholder: "",
                    ...inputProps,
                    ...props
                }}
                {...props}
                value={value1}
                onChange={onPhoneNumberChange}

            />
            {error && <Typography className="inputError ml-1">{error}</Typography>}

        </>
    )
}

export default PhoneCountryCodeInput
